


















































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import Table from '@/components/molecules/Table/Table.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import FilterTag from '@/componentsV2/molecules/FilterTag/FilterTag.vue';
import TableCard from '@/componentsV2/molecules/TableCard/TableCard.vue';
import EmptyStateTable from '@/componentsV2/molecules/EmptyStateTable/EmptyStateTable.vue';

import { IConversion } from '@/models/performance';

import { IPaginationTableHeader } from '@/utils/PaginationUtils';
import { copyToClipboard } from '@/utils';
import { EBusinessReportType } from '@/models/business';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    Table,
    TableCell,
    TableHeader,
    TableRow,
    FilterTag,
    TableCard,
    EmptyStateTable
  }
})
export default class ConversionsList extends Vue {
  @Prop() headers!: Record<string, IPaginationTableHeader>;
  @Prop() conversions!: IConversion[];

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get showTotalConverted() {
    return this.businessInfo.reportType !== EBusinessReportType.OFFER;
  }

  detail(rowData: Record<string, any>) {
    this.$emit('item-click', rowData);
    this.$router.push(`/performance/customer-center/${rowData.customer.id}`);
  }

  onCopy(coupon: string) {
    copyToClipboard(coupon, () => {
      this.$notification('Copied coupon code.');
    });
  }
}
